var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPoint = function SvgPoint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "point_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h16v16H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#point_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 14.4a6.238 6.238 0 0 1-2.483-.5 6.453 6.453 0 0 1-2.042-1.375A6.451 6.451 0 0 1 2.1 10.483 6.237 6.237 0 0 1 1.6 8c0-.889.167-1.72.5-2.492A6.45 6.45 0 0 1 5.517 2.1 6.237 6.237 0 0 1 8 1.6c.889 0 1.72.167 2.492.5A6.477 6.477 0 0 1 13.9 5.508c.333.773.5 1.603.5 2.492 0 .878-.167 1.706-.5 2.483a6.451 6.451 0 0 1-3.408 3.417A6.22 6.22 0 0 1 8 14.4Zm0-1.2c1.445 0 2.672-.506 3.683-1.517C12.694 10.673 13.2 9.444 13.2 8s-.505-2.672-1.517-3.683C10.673 3.306 9.445 2.8 8 2.8c-1.444 0-2.672.506-3.683 1.517C3.306 5.327 2.8 6.556 2.8 8s.506 2.672 1.517 3.683C5.327 12.694 6.556 13.2 8 13.2Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.724 11.535v-7.07H8.38c1.621 0 2.485.986 2.49 2.344-.005 1.352-.879 2.334-2.51 2.334H6.993v2.392h-1.27Zm1.27-3.437h1.19c.958-.005 1.387-.542 1.387-1.29 0-.756-.43-1.279-1.386-1.279H6.993v2.569Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 12,
    r: 3,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.458 14.388v-1.846h-1.846v-1.084h1.846V9.612h1.074v1.846h1.856v1.084h-1.856v1.846h-1.074Z",
    fill: "#404040"
  }))));
};
export default SvgPoint;